import React from 'react'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'
import { Trans } from 'react-i18next'

const MicrosoftLogo = () => (
    <svg width="21" height="21" viewBox="0 0 21 21" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#F25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
        <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
        <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
)

const GoogleLogo = () => (
    <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
        <path
            fill="#FFC107"
            d="M43.6 20.5H42V20H24v8h11.3C33.9 32.7 29.4 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 8 3l6-6C34.1 5.5 29.3 3.5 24 3.5 12.7 3.5 3.5 12.7 3.5 24S12.7 44.5 24 44.5 44.5 35.3 44.5 24c0-1.2-.1-2.4-.3-3.5z"
        />
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.1 18.9 12 24 12c3.1 0 5.8 1.1 8 3l6-6C34.1 5.5 29.3 3.5 24 3.5c-7.5 0-13.9 4.3-17.1 10.5z" />
        <path fill="#4CAF50" d="M24 44.5c5.2 0 9.9-1.9 13.5-5.1l-6.2-5.2C29.2 35.7 26.7 36.5 24 36.5c-5.3 0-9.8-3.3-11.4-7.9l-6.5 5C9.9 40 16.4 44.5 24 44.5z" />
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-1 2.8-2.9 5.1-5.4 6.7l6.2 5.2C39.8 36.9 44.5 31 44.5 24c0-1.2-.1-2.4-.3-3.5z" />
    </svg>
)

const SSO_PROVIDERS = [
    { id: 'microsoft', labelKey: 'signInWithMicrosoft', Logo: MicrosoftLogo },
    // { id: 'google', labelKey: 'signInWithGoogle', Logo: GoogleLogo },
]

const LoginForm = ({ email, setEmail, password, setPassword, onSubmit, onForgotPassword, onSSOLogin, ssoProviderLoading, isLoading, errorMessage, disabled }) => {
    const { t } = useTranslation()

    const handleSubmit = (e) => {
        e.preventDefault()
        onSubmit({ email, password })
    }

    return (
        <>
            <div className="">
                <div className="font-bold text-white text-left text-3xl">{t('staffLogin')}</div>
                <div className="text-mudPurple text-sm text-left mt-3">
                    <p>{t('enterYourWorkEmailAndPassword')}</p>
                </div>
                <div className="sign-up-section">
                    <div className="login-forma flex flex-col justify-center">
                        <form onSubmit={handleSubmit}>
                            <div className="my-5">
                                <span className="text-white text-lg font-semibold text-left flex justify-start">{t('email')}</span>
                                <input
                                    id="login-email-input"
                                    className="w-full text-white border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                    placeholder={t('email')}
                                    style={{ backgroundColor: 'transparent' }}
                                    value={email}
                                    name="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="my-5">
                                <span className="text-white text-lg font-semibold text-left flex justify-start">{t('password')}</span>
                                <input
                                    id="login-password-input"
                                    className="w-full text-white border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                    placeholder={t('password')}
                                    value={password}
                                    type="password"
                                    style={{ backgroundColor: 'transparent' }}
                                    onChange={(e) => setPassword(e.target.value)}
                                    name="passwordLogin"
                                />
                            </div>
                            <div className="error-message">{errorMessage}</div>
                            <div className="flex justify-center mt-8 mb-3">
                                <button
                                    id="login-button"
                                    className={`bg-highlightColor text-deepPurple py-3 text-lg font-semibold rounded-full w-full h-[50px] ${
                                        !isLoading && !disabled ? 'hover:bg-darkPurple hover:text-white' : ''
                                    } duration-[250ms] ease-in-out transition-all flex items-center justify-center`}
                                    disabled={isLoading || disabled}
                                >
                                    {isLoading ? <Loading primaryColor="#413F5E" /> : t('login')}
                                </button>
                            </div>
                        </form>
                        {onSSOLogin && (
                            <>
                                <div className="flex items-center my-3" aria-hidden="true">
                                    <div className="flex-1 border-t border-deselectPurple" />
                                    <span className="px-3 text-deselectPurple text-sm uppercase tracking-wide">{t('orSignInWith')}</span>
                                    <div className="flex-1 border-t border-deselectPurple" />
                                </div>
                                <div className="flex flex-row gap-3 mb-3">
                                    {SSO_PROVIDERS.map(({ id, labelKey, Logo }) => (
                                        <button
                                            key={id}
                                            id={`login-${id}-button`}
                                            type="button"
                                            className={`bg-white text-[#5E5E5E] py-3 text-lg font-semibold rounded-full flex-1 min-w-0 h-[50px] ${
                                                !ssoProviderLoading && !isLoading ? 'hover:bg-[#F3F3F3]' : ''
                                            } duration-[250ms] ease-in-out transition-all flex items-center justify-center gap-2`}
                                            disabled={!!ssoProviderLoading || isLoading}
                                            onClick={() => onSSOLogin(id)}
                                        >
                                            {ssoProviderLoading === id ? (
                                                <Loading primaryColor="#413F5E" />
                                            ) : (
                                                <>
                                                    <Logo />
                                                    {t(labelKey)}
                                                </>
                                            )}
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                    <div>
                        <p className="login-missing-text mb-2">
                            <span className="login-missing-text-q">{t('forgotPassword')}</span>
                            <span className="login-missing-text-action" id="request-new-password" onClick={onForgotPassword}>
                                {t('requestNewPassword')}
                            </span>
                        </p>
                        <p
                            className="login-missing-text mb-4"
                            style={{ color: '#FFFFFF99', cursor: 'pointer' }}
                            onClick={() => window.open('https://upstrive.de/for-schools-wellbeing-upstrive-education/', '_blank')}
                        >
                            <Trans
                                i18nKey="visitOurWebsiteForMoreDetails"
                                components={{
                                    white: <span className="text-white" />,
                                }}
                            />
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginForm
